export function parseContentDispositionFileName(header: string | null): string | null {
    if (!header) return null;

    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(header);
    if (utf8Match?.[1]) {
        try {
            return decodeURIComponent(utf8Match[1].trim());
        } catch {
            return utf8Match[1].trim();
        }
    }

    const quotedMatch = /filename="([^"]+)"/i.exec(header);
    if (quotedMatch?.[1]) return quotedMatch[1];

    const plainMatch = /filename=([^;]+)/i.exec(header);
    return plainMatch?.[1]?.trim() ?? null;
}

export function downloadBlob(blob: Blob, fileName: string): void {
    const href = globalThis.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = href;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    globalThis.URL.revokeObjectURL(href);
}
